import React from 'react';
import { IconBox } from '../../../assets/svg/icons';
import { StyledProductMonogram } from './styles';

// slice(0, 2) matches the marketplace monogram derivation; works for Arabic
// names too (toUpperCase is a no-op there).
const getMonogram = (name?: string | null): string =>
  (name ?? '').trim().slice(0, 2).toUpperCase() || '?';

const ProductMonogram: React.FC<{ name?: string | null; scale?: number }> = ({
  name,
  scale,
}) => (
  <StyledProductMonogram $scale={scale} aria-hidden='true'>
    <span>{getMonogram(name)}</span>
    <IconBox />
  </StyledProductMonogram>
);

export default ProductMonogram;
